import { Injectable } from "@angular/core";

import * as _ from "lodash";
import { of } from "rxjs";
import { AuthService } from "../auth/auth.service";
import { ConfigService } from "../config/config.service";
import { formatLocale } from "src/app/plasma-ui-common/utils/format-locale";
import { isInAvailableLocale } from "src/app/transloco-root.module";
import { LocalStorageKeys } from "src/app/models/storage.model";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(private authService: AuthService, private config: ConfigService) {}
  canActivate() {
    this.getLangCodeBeforeSigninCallback();
    const isLoggedIn = this.authService.isLoggedInObs();
    const sessionTransferObj = JSON.parse(localStorage.getItem("session-transfer"));

    if (sessionTransferObj != null && sessionTransferObj.accessToken) {
      this.authService.saveToState(sessionTransferObj.accessToken);
      return of(true);
    } else {
      isLoggedIn.subscribe((loggedin) => {
        if (!loggedin) {
          this.authService.signinRedirectTrigger$.next(Date.now());
        }
      });

      return isLoggedIn;
    }
  }

  private getLangCodeBeforeSigninCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const langCode = urlParams.get('langCode');

    if (langCode) {
      const configLanguages = this.config._envConfig?.AvailableLanguage?.split(',')
      let availableLanguages = [...(Array.isArray(configLanguages) ? configLanguages : [])]
        .map(locale => formatLocale(locale, <any>this.config._envConfig));

      const formattedLocale = formatLocale(isInAvailableLocale(langCode, availableLanguages), <any>this.config._envConfig);
      sessionStorage?.setItem(LocalStorageKeys.language, formattedLocale);
    }

  }
}
